import { useState } from 'react';

interface ImageGalleryProps {
  images: string[];
  productName: string;
}

export default function ImageGallery({ images, productName }: ImageGalleryProps) {
  const [selectedImage, setSelectedImage] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);

  return (
    <div className="space-y-4">
      {/* Main Image */}
      <div 
        className="relative w-full h-[600px] bg-black/20 rounded-lg overflow-hidden cursor-zoom-in group"
        onClick={() => setIsZoomed(!isZoomed)}
      >
        <img
          src={images[selectedImage]}
          alt={`${productName} - View ${selectedImage + 1}`}
          className={`w-full h-full object-cover object-top transition-transform duration-300 ${
            isZoomed ? 'scale-150' : 'scale-100 group-hover:scale-105'
          }`}
        />
        {isZoomed && (
          <div className="absolute top-4 right-4 bg-white/90 text-black px-3 py-1 rounded-full text-sm font-medium">
            Click to zoom out
          </div>
        )}
      </div>

      {/* Thumbnail Grid */}
      <div className="grid grid-cols-4 gap-3">
        {images.map((image, index) => (
          <button
            key={index}
            onClick={() => {
              setSelectedImage(index);
              setIsZoomed(false);
            }}
            className={`relative w-full h-32 bg-black/20 rounded-lg overflow-hidden transition-all duration-200 ${
              selectedImage === index
                ? 'ring-2 ring-white'
                : 'hover:ring-2 hover:ring-white/50'
            }`}
          >
            <img
              src={image}
              alt={`${productName} thumbnail ${index + 1}`}
              className="w-full h-full object-cover object-top"
            />
          </button>
        ))}
      </div>
    </div>
  );
}